import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { analizarMensaje, buscarTipo } from './gemini';
import useAutoLogout from "./useAutoLogout";

const API_BASE = "https://web.sconline.mx/chat_api/v1/dynamic";

const Home = () => {
    const navigate = useNavigate();
    const [usuario, setUsuario] = useState(null);
    const [session, setSession] = useState(null);
    const [mensajes, setMensajes] = useState([]);
    const [nuevoMensaje, setNuevoMensaje] = useState('');
    const [nameController, setNameController] = useState(null);
    const [nameMethods, setNameMethods] = useState([]);
    const [nameParams, setNameParams] = useState([]);
    const [generandoReporte, setGenerandoReporte] = useState(false);
    const [mostrarTutorial, setMostrarTutorial] = useState(false);
    const [paramsBlanza, setParamsBalanza] = useState([]);

    const mensajesEndRef = useRef(null);

    const [flujoParametrosActivo, setFlujoParametrosActivo] = useState(false);
    const [indiceParametroActual, setIndiceParametroActual] = useState(0);
    const [respuestasParametros, setRespuestasParametros] = useState([]);

    const handleLogout = () => {
        ["ultimaActividad", "isLoggedIn", "user", "session"].forEach(k => localStorage.removeItem(k));
        navigate('/', { replace: true });
        alert("Tu sesión ha expirado por inactividad.");
    };

    useAutoLogout(handleLogout);

    useEffect(() => {
        const isLoggedIn = localStorage.getItem('isLoggedIn');
        if (isLoggedIn !== 'true') {
            navigate('/', { replace: true });
            return;
        }

        const userData = localStorage.getItem('user');
        const sessionData = localStorage.getItem('session');
        if (userData) setUsuario(JSON.parse(userData));
        if (sessionData) setSession(JSON.parse(sessionData));

        if (!localStorage.getItem('tutorialVisto')) {
            setMostrarTutorial(true);
        }
    }, [navigate]);

    // Mostrar mensaje inicial cuando no hay mensajes previos
    useEffect(() => {
        if (usuario && mensajes.length === 0) {
            agregarMensaje(
                <div>
                    👋 ¡Hola <b>{usuario.session.nombre_usuario}</b>! Soy tu asistente contable 🤖.<br />
                    Puedo ayudarte a generar distintos tipos de reportes contables.<br />
                    Selecciona uno de la lista para comenzar 👇
                    <ul style={{ marginTop: '12px', marginBottom: '12px', listStyleType: 'none', paddingLeft: 0 }}>
                        {[
                            { nombre: 'Reporte de Estado de Resultados', texto: '📘 Estado de Resultados' },
                            { nombre: 'Reporte de Balance General', texto: '📗 Balance General' },
                            { nombre: 'Reporte de Pólizas', texto: '📕 Pólizas' },
                            { nombre: 'Reporte de Balanza de Comprobación', texto: '📙 Balanza de Comprobación' },
                            { nombre: 'Reporte de Libro Diario', texto: '📒 Libro Diario' },
                            { nombre: 'Reporte de Libro Mayor', texto: '📔 Libro Mayor' },
                            { nombre: 'Reporte Auxiliar de Cuentas', texto: '📓 Auxiliar de Cuentas' },
                            { nombre: 'Reporte de Recepción de Pagos', texto: '📑 Recepción de Pagos' }
                        ].map((r, i) => (
                            <li
                                key={i}
                                onClick={() => realizarFetchLi(r.nombre)}
                                style={{
                                    textDecoration: 'underline',
                                    backgroundColor: '#f3f4f6',
                                    border: '1px solid #d0dafdff',
                                    borderRadius: '8px',
                                    marginBottom: '6px',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s ease',
                                }}
                                onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#d0dafdff')}
                                onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#f3f4f6')}
                            >
                                {r.texto}
                            </li>
                        ))}
                    </ul>
                </div>
            );
        }
    }, [usuario, mensajes.length]);


    const mostrarListaReportes = (number) => {
        agregarMensaje(
            <div>
                {number === 1 ? <p>¿Deseas que te ayude con algún reporte más? Te puedo ayudar con los siguientes reportes contables:</p> : <p>Te puedo ayudar con los siguientes reportes contables:</p>}
                <ul style={{ marginTop: '12px', marginBottom: '12px', listStyleType: 'none', paddingLeft: 0 }}>
                    {[
                        { nombre: 'Reporte de Estado de Resultados', texto: '📘 Estado de Resultados' },
                        { nombre: 'Reporte de Balance General', texto: '📗 Balance General' },
                        { nombre: 'Reporte de Pólizas', texto: '📕 Pólizas' },
                        { nombre: 'Reporte de Balanza de Comprobación', texto: '📙 Balanza de Comprobación' },
                        { nombre: 'Reporte de Libro Diario', texto: '📒 Libro Diario' },
                        { nombre: 'Reporte de Libro Mayor', texto: '📔 Libro Mayor' },
                        { nombre: 'Reporte Auxiliar de Cuentas', texto: '📓 Auxiliar de Cuentas' },
                        { nombre: 'Reporte de Recepción de Pagos', texto: '📑 Recepción de Pagos' }
                    ].map((r, i) => (
                        <li
                            key={i}
                            onClick={() => realizarFetchLi(r.nombre)}
                            style={{
                                textDecoration: 'underline',
                                backgroundColor: '#f3f4f6',
                                border: '1px solid #d0dafdff',
                                borderRadius: '8px',
                                marginBottom: '6px',
                                cursor: 'pointer',
                                transition: 'background-color 0.2s ease',
                            }}
                            onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#d0dafdff')}
                            onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#f3f4f6')}
                        >
                            {r.texto}
                        </li>
                    ))}
                </ul>
            </div>
        );
    };


    //Tutorial

    const pasosTutorial = [
        {
            titulo: "Bienvenido a ContaBot",
            descripcion: "Este asistente te ayudará a generar reportes contables de forma rápida y sencilla.",
            imagen: "/imagenes/tutorial1.png"
        },
        {
            titulo: "Escribe tu solicitud",
            descripcion: "Indica el tipo de reporte que necesitas, por ejemplo 'Reporte de Balanza de Comprobación'.",
            imagen: "/imagenes/tutorial2.png"
        },
        {
            titulo: "Proporciona datos",
            descripcion: "El chat te pedira los datos necesarios para poder generar tu reporte.",
            imagen: "/imagenes/tutorial3.png"
        },
        {
            titulo: "Descarga tu reporte",
            descripcion: "Recibirás un enlace para descargar el reporte en formato PDF o Excel.",
            imagen: "/imagenes/tutorial4.png"
        }
    ];

    const [pasoActual, setPasoActual] = useState(0);

    // Función para avanzar
    const siguientePaso = () => {
        if (pasoActual < pasosTutorial.length - 1) {
            setPasoActual(pasoActual + 1);
        } else {
            cerrarTutorial();
            setPasoActual(0);
        }
    };

    // Función para retroceder
    const pasoAnterior = () => {
        if (pasoActual > 0) {
            setPasoActual(pasoActual - 1);
        }
    };
    const cerrarTutorial = () => {
        localStorage.setItem('tutorialVisto', 'true');
        setMostrarTutorial(false);
    };

    // --- Funciones utilitarias ---
    const realizarFetch = async (url, body) => {
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(body)
            });
            if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);
            return await response.json();
        } catch (error) {
            console.error(`❌ Error en la solicitud a ${url}:`, error);
            throw error;
        }
    };

    const agregarMensaje = (texto, emisor = 'asistente') => {
        setMensajes(prev => [...prev, { texto, emisor, fecha: new Date().toLocaleTimeString() }]);
    };

    const eliminarMensajeTemporal = texto => {
        setMensajes(prev => prev.filter(msg => msg.texto !== texto));
    };

    const cerrarSesion = () => {
        ["ultimaActividad", "isLoggedIn", "user", "session"].forEach(k => localStorage.removeItem(k));
        navigate('/', { replace: true });
    };

    // --- Obtener controladores dinámicos ---
    const realizarFetchLi = async nombre => {
        const controladores = {
            'Reporte de Pólizas': 'ReportePolizaController',
            'Reporte de Balanza de Comprobación': 'ReporteBalanzaController',
            'Reporte de Libro Diario': 'ReporteDiarioController',
            'Reporte Auxiliar de Cuentas': 'ReporteAuxiliarCuentasController',
            'Reporte de Libro Mayor': 'ReporteMayorController',
            'Reporte de Estado de Resultados': 'ReporteEstadoResultadosController',
            'Reporte de Balance General': 'ReporteBalanceGeneralController',
            'Reporte de Recepción de Pagos': 'ReporteRecepcionPagosController'
        };

        const nombreController = controladores[nombre];
        if (!nombreController) return console.warn(`No existe controlador para: ${nombre}`);

        setNameController(nombreController);

        try {
            const data = await realizarFetch(`${API_BASE}/methods`, { nameController: nombreController });
            const metodos = data.metodos_encontrados || [];

            setNameMethods(metodos);
            const mensaje =
                metodos.length > 1
                    ? `Las formas de generar tu reporte son: ${metodos.join(' o ')}.`
                    : metodos.length === 1
                        ? `La forma de generar tu reporte es: ${metodos[0]}.`
                        : 'No se encontraron métodos.';

            agregarMensaje(mensaje);
        } catch (error) {
            console.error('Error al obtener métodos:', error);
            agregarMensaje('❌ Error al obtener métodos disponibles.');
        }
    };

    // --- Procesar envío de mensajes ---
    const enviarMensaje = async e => {
        e.preventDefault();
        if (!nuevoMensaje.trim()) return;

        const texto = nuevoMensaje.trim();
        agregarMensaje(texto, usuario?.session?.nombre_usuario);
        setNuevoMensaje('');

        try {
            if (flujoParametrosActivo) return manejarFlujoParametros(texto);

            const analisis = await analizarMensaje(texto.toLowerCase());
            if (!analisis) return agregarMensaje('No entendí tu solicitud.');

            // Detectar tipo de acción
            if (analisis === '1') {
                agregarMensaje('Por el momento, solo puedo generar un reporte a la vez. Por favor solicita cada reporte por separado.');
                mostrarListaReportes(0)
            } else if (analisis[0] === '2') {
                agregarMensaje('Para poder generar tu reporte correctamente, por favor sigue las instrucciones paso a paso que te iré indicando');
                var nCp = analisis.substring(1);
                //console.log(nCp);
                const controllerResp = await realizarFetch(`${API_BASE}/name`, { keyword: nCp });
                setNameController(controllerResp);

                const methodsResp = await realizarFetch(`${API_BASE}/methods`, { nameController: controllerResp });
                const metodos = methodsResp.metodos_encontrados || [];
                setNameMethods(metodos);

                agregarMensaje(
                    metodos.length
                        ? `Las formas de generar tu reporte son: ${metodos.join(' o ')}.`
                        : 'No se encontraron métodos.'
                );
            } else if (analisis === 'pdf' || analisis === 'excel') {
                //console.log('NameController: ' + nameController + ' //')
                if (nameController === null) {
                    agregarMensaje('❌ Error: Se necesita el tipo de reporte primero');
                } else {
                    const metodo = analisis === 'pdf' ? 'actionPdfApi' : 'actionExcelApi';
                    setNameMethods(metodo);
                    const params = await realizarFetch(`${API_BASE}/params`, { nameController, nameMethod: metodo });
                    setNameParams(params);
                    iniciarFlujoParametros(params);
                }
            } else if (analisis === 'ninguno') {
                agregarMensaje('❌ Error: palabra incorrecta. Escribe correctamente la forma en la que deseas tu reporte.')
            } else {
                const validar = await buscarTipo(analisis);

                // 🧠 Nueva validación: si ya hay un flujo activo o un reporte definido
                if (flujoParametrosActivo || generandoReporte) {
                    agregarMensaje('⚠️ Solo se puede generar un reporte a la vez. Termina el actual antes de iniciar otro.');
                    return;
                }

                if (validar === '1') {
                    // 🔁 Flujo general para los demás tipos de reporte
                    const controllerResp = await realizarFetch(`${API_BASE}/name`, { keyword: analisis });
                    setNameController(controllerResp);

                    const methodsResp = await realizarFetch(`${API_BASE}/methods`, { nameController: controllerResp });
                    const metodos = methodsResp.metodos_encontrados || [];
                    setNameMethods(metodos);

                    agregarMensaje(
                        metodos.length
                            ? `Las formas de generar tu reporte son: ${metodos.join(' o ')}.`
                            : 'No se encontraron métodos.'
                    );
                }
            }

        } catch (error) {
            console.error('Error al procesar mensaje:', error);
            agregarMensaje('❌ Hubo un problema al procesar tu solicitud.');
        }
    };

    // --- Flujo de parámetros ---
    const iniciarFlujoParametros = params => {
        setFlujoParametrosActivo(true);
        setIndiceParametroActual(0);
        setRespuestasParametros([]);
        agregarMensaje('A continuación se te pedirán los datos necesarios:');
        agregarMensaje(params[0]);
    };

    const manejarFlujoParametros = async respuesta => {
        const nuevas = [...respuestasParametros, respuesta];
        setRespuestasParametros(nuevas);

        const siguiente = indiceParametroActual + 1;
        if (siguiente < nameParams.length) {
            agregarMensaje(nameParams[siguiente]);
            setIndiceParametroActual(siguiente);
            return;
        }

        setFlujoParametrosActivo(false);
        agregarMensaje('✅ Todos los datos han sido capturados.');
        setGenerandoReporte(true);
        agregarMensaje('⏳ Generando tu reporte, por favor espera...');

        try {
            if (nameController === 'ReporteBalanzaController') {
                const parametrosBalanza = await realizarFetch('https://web.sconline.mx/chat_api/v1/dynamic/reporte', {
                    session: session,
                    nameController: nameController,
                    nameMethod: nameMethods,
                    params: nuevas
                })
                setParamsBalanza(parametrosBalanza);
                fetch('https://balancepro.sconline.mx:444/', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        todas_cuentas: parametrosBalanza[2],
                        administrativa: 0,
                        amayor: parametrosBalanza[3],
                        id_contribuyente: usuario.session.id_contribuyente,
                        cierre: parametrosBalanza[4],
                        anio: parametrosBalanza[0],
                        mes: parametrosBalanza[1],
                        tipo_salida: 4,
                        decimales: 2
                    }),
                })
                    .then(response => response.blob())
                    .then(blob => {
                        const url = window.URL.createObjectURL(blob);
                        const nombreArchivo = `REPORTE_BALANZA_COMPROBACION_${new Date().toISOString().slice(0, 10)}_${usuario.session.rfc_contribuyente}.xlsx`;
                        setGenerandoReporte(false);
                        eliminarMensajeTemporal('⏳ Generando tu reporte, por favor espera...');
                        agregarMensaje(
                            <a href={url} download={nombreArchivo} target='_black' rel='noonpener noreferrer' style={styles.link_descarga}>
                                Haz clic aqui para ver el archivo
                            </a>
                        );
                        mostrarListaReportes(1);
                    })
                    .catch(error => {
                        agregarMensaje('❌ Error al generar el archivo');
                        agregarMensaje("Asegurate de ingresar los datos correctamente.");
                        mostrarListaReportes();
                        console.error('Error descargando el archivo:', error);
                    });
            } else {
                const prueba = await realizarFetch(`${API_BASE}/reporte`, {
                    session,
                    nameController,
                    nameMethod: nameMethods,
                    params: nuevas
                });
                procesarReporte(prueba);
            }
        } catch {
            agregarMensaje('❌ Error al generar el reporte.');
            agregarMensaje("Asegurate de ingresar los datos correctamente.");
            mostrarListaReportes();
        } finally {
            setGenerandoReporte(false);
            eliminarMensajeTemporal('⏳ Generando tu reporte, por favor espera...');
        }
    };

    const procesarReporte = prueba => {
        if (!prueba?.resultado?.success) {
            if (prueba.resultado.error === 'Date') {
                agregarMensaje('❌ Ingresaste el formato de las fechas incorrectamente');
                agregarMensaje('Realiza el proceso nuevamente');
                mostrarListaReportes();
            } else if (prueba.resultado.error === 'Cuenta'){
                agregarMensaje('❌ Ingresaste un tipo de cuenta no valido');
                agregarMensaje('Realiza el proceso nuevamente');
                mostrarListaReportes();
            } else if(prueba.resultado.error === 'VariasPolizas'){
                agregarMensaje('❌ No es posible generar un reporte con mas de un tipo de póliza');
                agregarMensaje('Realiza el proceso nuevamente');
                mostrarListaReportes();
            } else if(prueba.resultado.error === 'Tipo'|| prueba.resultado.error === 'Cuenta'){
                agregarMensaje('❌ Ingresaste el tipo de cuenta de forma incorrecta');
                agregarMensaje('Realiza el proceso nuevamente');
                mostrarListaReportes();
            } else if(prueba.resultado.error === 'DateIm'){
                agregarMensaje('❌ La fecha inicial no puede ser mayor a la fecha final');
                agregarMensaje('Realiza el proceso nuevamente');
                mostrarListaReportes();
            }else if(prueba.resultado.error === 'CFDIrelacionado'){
                agregarMensaje(':x: No se puede generar el reporte con los 2 tipos de CFDI relacionados');
                agregarMensaje('Realiza el proceso nuevamente');
                mostrarListaReportes();
            }else {
                agregarMensaje("❌ No se pudo generar el archivo correctamente.");
                agregarMensaje("Asegurate de ingresar los datos correctamente.");
                mostrarListaReportes();
            }

            return;
        }

        const { pdf_base64, excel_base64, filename, nombre_archivo, url } = prueba.resultado;

        if (pdf_base64) {
            crearEnlaceDescarga(pdf_base64, 'application/pdf', filename || 'reporte.pdf');
        } else if (excel_base64) {
            crearEnlaceDescarga(
                excel_base64,
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                nombre_archivo || 'reporte.xlsx'
            );
        } else if (url) {
            agregarMensaje(
                <a href={url} target="_blank" rel="noopener noreferrer" style={styles.link_descarga}>
                    Ver reporte
                </a>
            );
        }

        mostrarListaReportes(1);
    };

    const crearEnlaceDescarga = (base64, type, nombre) => {
        const blob = new Blob([Uint8Array.from(atob(base64), c => c.charCodeAt(0))], { type });
        const url = URL.createObjectURL(blob);
        agregarMensaje(
            <a href={url} download={nombre} target="_blank" rel="noopener noreferrer" style={styles.link_descarga}>
                Descargar archivo
            </a>
        );
    };

    useEffect(() => {
        mensajesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [mensajes]);

    return (
        <div style={styles.principal} className="min-h-screen flex flex-col bg-gradient-to-br from-blue-100 to-indigo-100">
            {/* Navbar */}
            <nav className="bg-white shadow-md px-6 py-4 flex justify-between items-center border-b border-blue-200 sticky top-0 z-10">
                <h1 style={styles.title} className="text-2xl font-bold text-indigo-700">
                    <img src='/default_pie_.svg' alt="Logo de ContaBot" className="inline-block w-6 h-6 mr-2" />
                    ContaBot
                </h1>

                {usuario && (
                    <div className="flex items-center gap-4">
                        <button
                            onClick={() => {
                                setMostrarTutorial(true);
                                setPasoActual(0);
                            }}
                            className="text-blue-600"
                            style={styles.button_salir}
                        >
                            <b>Ver tutorial</b>
                        </button>
                        <button onClick={cerrarSesion} style={styles.button_salir}>
                            <b>Salir ({usuario.session.nombre_usuario})</b>
                        </button>
                    </div>
                )}
            </nav>

            {/* Chat */}
            <div className="flex-1 flex flex-col justify-between p-6 max-w-3xl mx-auto w-full">
                <div className="flex-1 overflow-y-auto bg-white rounded-lg shadow-md p-6 space-y-4 border border-gray-200">
                    {mensajes.map((msg, i) => (
                        <div key={i} className={`max-w-xs p-3 rounded-lg shadow-sm ${msg.emisor === usuario?.session.nombre_usuario ? 'bg-indigo-100 ml-auto text-right' : 'bg-gray-100 mr-auto text-left'}`}>
                            <p className="text-sm text-gray-800">{msg.texto}</p>
                            <span className="text-xs text-gray-500 block mt-1">{msg.fecha}</span>
                        </div>
                    ))}
                    <div ref={mensajesEndRef} />
                </div>

                {/* Input */}
                <form style={styles.form} onSubmit={enviarMensaje} className="mt-4 flex gap-2 sticky bottom-0 bg-white p-4 border-t border-gray-200">
                    <textarea
                        value={nuevoMensaje}
                        onChange={e => setNuevoMensaje(e.target.value)}
                        onKeyDown={e => {
                            if (e.key === 'Enter' && !e.shiftKey) {
                                e.preventDefault(); // Evita salto de línea
                                enviarMensaje(e);   // Envía el mensaje
                            }
                        }}
                        placeholder="Escribe tu mensaje..."
                        rows={1}
                        className="flex-1 px-4 py-3 rounded-2xl border border-gray-300 shadow focus:outline-none focus:ring-2 focus:ring-indigo-300 resize-none"
                    />
                    <button style={styles.button} type="submit" className="bg-indigo-600 text-white px-5 py-3 rounded-full shadow hover:bg-indigo-700 transition">
                        Enviar
                    </button>
                </form>
            </div>
            {/* Modal del tutorial */}
            {mostrarTutorial && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white p-4 sm:p-6 rounded-lg shadow-lg w-full max-w-lg flex flex-col items-center mx-4">

                        {/* Imagen responsiva */}
                        <img
                            src={pasosTutorial[pasoActual].imagen}
                            alt={pasosTutorial[pasoActual].titulo}
                            className="w-full max-w-sm sm:max-w-md h-auto object-contain mb-4"
                        />

                        {/* Título */}
                        <h2 className="text-lg sm:text-xl font-bold mb-2 text-center">
                            {pasosTutorial[pasoActual].titulo}
                        </h2>

                        {/* Descripción */}
                        <p className="text-gray-600 text-sm sm:text-base text-center mb-4">
                            {pasosTutorial[pasoActual].descripcion}
                        </p>

                        {/* Botones de navegación */}
                        <div className="flex justify-between w-full mt-4">
                            <button
                                onClick={pasoAnterior}
                                disabled={pasoActual === 0}
                                className={`px-3 py-2 rounded text-sm sm:text-base ${pasoActual === 0 ? "bg-gray-300 cursor-not-allowed" : "bg-indigo-500 text-white hover:bg-indigo-600"}`}
                            >
                                Anterior
                            </button>
                            <button
                                onClick={siguientePaso}
                                className="px-3 py-2 rounded text-sm sm:text-base bg-green-500 text-white hover:bg-green-600"
                            >
                                {pasoActual === pasosTutorial.length - 1 ? "Finalizar" : "Siguiente"}
                            </button>
                        </div>

                        {/* Indicadores */}
                        <div className="flex mt-4">
                            {pasosTutorial.map((_, index) => (
                                <span
                                    key={index}
                                    className={`h-3 w-3 mx-1 rounded-full ${index === pasoActual ? "bg-indigo-500" : "bg-gray-300"}`}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

const styles = {
    title: { color: '#222D63' },
    button_salir: {
        padding: 10,
        color: '#A69245',
        border: 'none',
        fontSize: '16px',
    },
    button: {
        padding: 10,
        backgroundColor: '#222D63',
        color: 'white',
        border: '2px solid #A69245',
        fontSize: '16px',
        borderRadius: '20px',
    },
    link_descarga: { color: '#bb053bff' },
    form: { borderRadius: '10px' },
    principal: { backgroundImage: 'url("/BGCP.JPG")', }
};

export default Home;
